var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmiLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    width: 66,
    height: 30,
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 66 30"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.262 23.257 1.002 3.908c-2.081 1.37-4.508 2.052-7.283 2.052-3.083 0-5.518-.877-7.304-2.632C.893 24.831 0 22.419 0 19.348c0-3.096.829-5.573 2.486-7.432 1.657-1.857 3.834-2.785 6.532-2.785 2.467 0 4.418.812 5.857 2.438 1.439 1.626 2.159 3.885 2.159 6.773 0 .696-.039 1.354-.116 1.974H5.01v.039c.179 1.522.744 2.69 1.695 3.502.95.813 2.248 1.219 3.892 1.219 2.107-.001 3.995-.606 5.665-1.819M5.125 16.832h7.052c-.026-1.136-.334-2.051-.924-2.747-.591-.697-1.375-1.045-2.352-1.045-2.029 0-3.288 1.263-3.776 3.792M60.572.918C61.169.307 61.918 0 62.82 0c.9 0 1.656.307 2.266.918S66 2.276 66 3.156c0 .905-.305 1.658-.914 2.259-.609.599-1.365.897-2.266.897-.902 0-1.651-.299-2.248-.897-.598-.601-.896-1.354-.896-2.259.001-.88.299-1.627.896-2.238M58.986 9.589v3.889h1.602v15.278h4.736V9.589zM36.961 23.606 31.78 9.589h-4.313l-7.084 19.169h5.005l4.236-12.018 2.421 6.866zM48.689 9.589h-4.314l-5.179 14.017h4.915l2.422-6.867 4.237 12.019h5.003z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.995 25.286a2.08 2.08 0 0 1-1.917 1.283c-.862 0-1.604-.53-1.916-1.283h-3.513C33.039 27.948 35.32 30 38.078 30c2.757 0 5.039-2.052 5.429-4.714z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmiLogoFooter);
export default __webpack_public_path__ + "static/media/emi_logo_footer.ecfa191274e05e9d4ce272e5587dec7a.svg";
export { ForwardRef as ReactComponent };